import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GridFilterSelect } from './GridFilterSelect';
import { EntityState } from '@api/models/enums/EntityState';

const options = Object.values(EntityState);

interface Props {
  value?: EntityState;
  onChange: (value?: EntityState) => void;
}

export const GridFilterState: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <GridFilterSelect
      value={value}
      options={options}
      onChange={onChange}
      getOptionId={(option: EntityState) => option}
      getOptionName={(option: EntityState) => t(`entityState.${option}`)}
    />
  );
};
